import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { requestCreateUserActivity } from '@/common/api/requests-activity-log'
import SearchPage from '@/pages/organizations/join/search'
import type { SortDir } from '@/common/hooks/useOrganizationSearch'

type SearchParams = { q?: string; page?: number; sort?: SortDir }

// Dedupe the "registration_started" activity log per org-type for the current
// session, so repeated navigation (pagination, sort, re-search) doesn't spam it.
const loggedMachineNames = new Set<string>()

export const Route = createFileRoute('/app/organizations/join/$orgtypeMachineName/find')({
  validateSearch: (raw: Record<string, unknown>): SearchParams => {
    const qRaw = raw.q
    const pageRaw = Number(raw.page)
    const sortRaw = raw.sort
    return {
      q: typeof qRaw === 'string' && qRaw.length > 0 ? qRaw : undefined,
      page: Number.isFinite(pageRaw) && pageRaw > 0 ? pageRaw : undefined,
      sort: sortRaw === 'desc' ? 'desc' : sortRaw === 'asc' ? 'asc' : undefined,
    }
  },
  beforeLoad: ({ context, params }) => {
    requireAuth(context)
    if (!loggedMachineNames.has(params.orgtypeMachineName)) {
      loggedMachineNames.add(params.orgtypeMachineName)
      requestCreateUserActivity(
        'organization_type',
        params.orgtypeMachineName,
        'registration_started'
      )
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { orgtypeMachineName } = Route.useParams()
  const { q, page, sort } = Route.useSearch()
  return <SearchPage orgTypeMachineName={orgtypeMachineName} q={q} page={page} sort={sort} />
}
